export default class RegistrationController {
  constructor(PasswordRecovery, $stateParams, $state) {
    'ngInject';

    this.$state = $state;
    this.PasswordRecovery = PasswordRecovery;
    this.resetPasswordRequest = { reset_password_token: $stateParams.reset_password_token };
    this.errors = [];
  }

  handleResetPasswordSubmit($event) {
    this.errors = [];

    this.PasswordRecovery.sendRequest(this.resetPasswordRequest)
      .then((response) => {
        this.resetPasswordRequest.submitted = true;
        return this.$state.go('engineer.dashboard');
      })
      .catch((response) => {
        this.errors = response.data.errors;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/guest/screens/password-recovery/password-recovery.controller.js